'use strict';

;( () => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'ticker', ( target ) => ({

			counter: 0,

			animateValue() {

				const targetNumeric = parseInt( target.match( /\d+/g ) );
				const targetNonNumeric = target.match( /\D+/g );

				const start = 0;
				const duration = 750;
				let startTimestamp = null;

				const step = ( timestamp ) => {
					if ( ! startTimestamp ) startTimestamp = timestamp;
					const progress = Math.min( ( timestamp - startTimestamp ) / duration, 1 );
					this.counter = Math.floor( progress * ( targetNumeric - start ) + start ) + targetNonNumeric;
					if ( 1 >= progress ) window.requestAnimationFrame( step );
				};

				window.requestAnimationFrame( step );
			},
		}) );
	});
})();
